/****** CUTOMIZATIONS:
 * - added AdditionalColumn component and changed width of columns
 * - added google analytics
 */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid } from 'semantic-ui-react';

import { flattenHTMLToAppURL } from '@plone/volto/helpers';
import { UniversalLink } from '@plone/volto/components';

import { getEditableFooterColumns, getItemsByPath } from 'volto-editablefooter';
import { SiteFooterMenu } from 'iovisit-theme/components/layout';

import config from '@plone/volto/registry';
import AdditionalColumn from 'iovisit-museum-cremona/components/layout/Footer/AdditionalColumn';

const FooterMain = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const footerConfiguration = useSelector(
    (state) => state.editableFooterColumns?.result,
  );

  useEffect(() => {
    dispatch(getEditableFooterColumns());
  }, [dispatch, location]);

  //filter rootpaths
  const footerColumns = getItemsByPath(
    footerConfiguration,
    location?.pathname?.length ? location.pathname : '/',
  );

  const LogoFooter = config.settings.iovisit.logoFooter;

  return (
    <div className="iv--footer-main">
      <Container>
        <div className="iv--logo">
          <UniversalLink href="/">
            <LogoFooter />
            <div className="iv--brand-text">
              {config.settings.iovisit.siteName}
            </div>
          </UniversalLink>
        </div>

        <Grid stackable verticalAlign="top">
          {config.settings.iovisit.showFooterMenu && (
            <Grid.Column
              width={3}
              className="iv--footer-column iv--footer-column-menu"
            >
              <SiteFooterMenu />
            </Grid.Column>
          )}
          {footerColumns
            ?.filter((column) => column.visible)
            ?.map((column, i) => (
              <Grid.Column width={3} className="iv--footer-column" key={i}>
                {column?.text?.data && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: flattenHTMLToAppURL(column.text.data),
                    }}
                  />
                )}
              </Grid.Column>
            ))}
          <Grid.Column width={3} textAlign="center">
            <AdditionalColumn />
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

export default FooterMain;
